import Actions                  from 'Redux/Actions';
import { EmployeeRepository }   from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const updateEmployeeEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.updateEmployeeRequest.type),
    mergeMap(action => from(EmployeeRepository.update(action.payload.id, action.payload.formData))
      .pipe(
        mergeMap((employee) => {
          message.success('Die Speicherung des Nutzers erfolgreich.');

          return from([
            Actions.updateEmployeeSuccess({ employee }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.updateEmployeeFailure({ error })
          ]);
        })
      )
    ),
  );
};
